export default `
mutation DeleteCompareList($uid: ID!) {
  deleteCompareList(uid: $uid) {
    result
  }
}
`;
